import {
  GIOTALK_CHANNEL_SETTINGS_UPDATE,
  GIOTALK_CHANNEL_SETTINGS_UPDATE_REQUEST,
  GIOTALK_MODIFICAR_NOTIFICACIONES,
  GIOTALK_INCREMENTAR_NO_LEIDAS,
  GIOTALK_OBTENER_NOTIFICACIONES_REQUEST,
  GIOTALK_NOTIFICACIONES_LIMPIAR,
  GIOTALK_NOTIFICACIONES_MARCAR_TODO_LEIDO,
  GIOTALK_NOTIFICACIONES_SUSCRIPCIONES_REQUEST,
  GIOTALK_NOTIFICACIONES_ESTABLECER_SUSCRIPCIONES,
  GIOTALK_CHATS_ESTABLECER_CHAT_ACTUAL,
  GIOTALK_CHATS_ENVIAR_MENSAJE_A_CHAT_REQUEST,
  GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES_REQUEST,
  GIOTALK_CHATS_CREAR_REQUEST,
  GIOTALK_CHATS_OBTENER_REQUEST,
  GIOTALK_ABANDONAR_CHAT,
  GIOTALK_INSERTAR_USUARIOS_REQUEST,
  GIOTALK_ABRIR_CHAT_CON_USUARIO,
} from '../constants/giotalk.constants';

export const actualizarOpcionesCanalRequest = ({canalId, opciones}) => ({
  type: GIOTALK_CHANNEL_SETTINGS_UPDATE_REQUEST,
  payload: {
    canalId,
    opciones,
  },
});

export const actualizarOpcionesCanal = ({canalId, opciones}) => ({
  type: GIOTALK_CHANNEL_SETTINGS_UPDATE,
  payload: {
    canalId,
    opciones,
  },
});

export const establecerNumerosNotificaciones = ({datos, total, totalNoLeido }) => ({
  type: GIOTALK_MODIFICAR_NOTIFICACIONES,
  payload: {
    total,
    totalNoLeido,
    datos,
  },
});

export const incrementarNoLeidas = () => ({
  type: GIOTALK_INCREMENTAR_NO_LEIDAS
});

export const obtenerNotificacionesDesdeSevidor = ({ marcarComoLeido }) => ({
  type: GIOTALK_OBTENER_NOTIFICACIONES_REQUEST,
  payload: {
    marcarComoLeido
  },
});

export const limpiarNotificaciones = () => ({
  type: GIOTALK_NOTIFICACIONES_LIMPIAR,
});

export const marcarNotificacionesLeidas = () => ({
  type: GIOTALK_NOTIFICACIONES_MARCAR_TODO_LEIDO,
});

export const obtenerSuscripcionesDesdeServidor = () => ({
  type: GIOTALK_NOTIFICACIONES_SUSCRIPCIONES_REQUEST,
});

export const establecerSubscripcionesNotificaciones = ({ subscripciones }) => ({
  type: GIOTALK_NOTIFICACIONES_ESTABLECER_SUSCRIPCIONES,
  payload: {
    subscripciones,
  },
});

export const establecerChatIdActual = ({ id }) => ({
  type: GIOTALK_CHATS_ESTABLECER_CHAT_ACTUAL,
  payload: {
    id,
  },
});

export const enviarMensajeAChat = ({ mensaje, chatId }) => ({
  type: GIOTALK_CHATS_ENVIAR_MENSAJE_A_CHAT_REQUEST,
  payload: {
    mensaje,
    chatId,
  },
});

export const buscarMensajes = ({ chatId, primeraCarga }) => ({
  type: GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES_REQUEST,
  payload: {
    chatId,
    primeraCarga,
  },
});

export const obtenerChatsDesdeServidor = () => {
  return {
    type: GIOTALK_CHATS_OBTENER_REQUEST
  };
};


export const crearChat = ({ name, usuarios }) => {
  return {
    type: GIOTALK_CHATS_CREAR_REQUEST,
    payload: {
      name,
      usuarios
    },
  };
};

export const abandonarChat = ({ chatId }) => {
  return {
    type: GIOTALK_ABANDONAR_CHAT,
    payload: {
      chatId,
    },
  };
};

export const insertarUsuariosEnChat = ({ chatId, usuarios }) => {
  return {
    type: GIOTALK_INSERTAR_USUARIOS_REQUEST,
    payload: {
      chatId,
      usuarios,
    },
  };
};

export const abrirChatConUsuario = ({ usuario }) => {
  return {
    type: GIOTALK_ABRIR_CHAT_CON_USUARIO,
    payload: {
      usuario,
    },
  };
};
